import { Controller } from "stimulus";
import Events from "../classes/Events";
import axios from 'axios';

const TOGGLE_BUTTON_CLASS = ['t-border', 't-rounded-full', 't-border-grey', 't-flex', 't-items-center', 't-cursor-pointer', 't-w-12', 't-bg-mitre-gray-225', 't-justify-start', 'n-toggle', 't-transition-all'];

const TOGGLE_KNOB_CLASS = ['t-rounded-full', 't-border', 't-w-6', 't-h-6', 't-border-grey', 't-shadow-inner', 't-bg-white', 't-shadow', 'n-toggle-knob'];

class ToggleController extends Controller {
  static targets = [
    'toggle'
  ]

  static values = { 
    url: String,
    state: String
  }

  connect() {
    this.createToggleElement();
  }

  createToggleElement = () => {
    this.toggleTargets.map(toggleContainer => {
      const toggleButton = document.createElement('span');
      toggleButton.classList.add(...TOGGLE_BUTTON_CLASS);
      const toggleKnob = document.createElement('span');
      toggleKnob.classList.add(...TOGGLE_KNOB_CLASS);
      toggleButton.appendChild(toggleKnob);
      toggleContainer.appendChild(toggleButton);
    });
  }

  onToggle = e => {
    const { target } = e;
    const toggleButtonContainer = target.closest('[data-toggle-target="toggle"]');
    if(this.stateValue == 'ON') {
      toggleButtonContainer.dispatchEvent(Events.toggleOffEvent);
    } else if(this.stateValue == 'OFF') {
      toggleButtonContainer.dispatchEvent(Events.toggleOnEvent);
    }
  }

  toggleButton = () => {
    if(this.stateValue == 'ON') {
      this.stateValue = 'OFF';
    } else if(this.stateValue == 'OFF') {
      this.stateValue = 'ON';
    }
  }

  stateValueChanged() {
    if(this.stateValue == 'ON') {
      this.toggleTarget.querySelector('.n-toggle').classList.add('n-toggle__on');
    } else if(this.stateValue == 'OFF') {
      this.toggleTarget.querySelector('.n-toggle').classList.remove('n-toggle__on');
    }
  }

  makeRequest = e => {
    e.preventDefault();
    const { target } = e;
    const toggleButtonContainer = target.closest('[data-toggle-target="toggle"]');
    const param = {};
    param[toggleButtonContainer.dataset.fieldKey] = this.stateValue;
    axios.post(this.urlValue, param).then(res => {
      if (res.data.error) {
        EventManager.emit('flash-message', {
          status: 'ERROR',
          title: 'Something went wrong'
        });
      } else {
        toggleButtonContainer.dispatchEvent(Events.successEvent);
      }
    }).catch(() => {
      EventManager.emit('flash-message', {
        status: 'ERROR',
        title: 'Something went wrong'
      });
    });
  }
}

export default ToggleController;
